import "swiper/css/pagination";

import { ApiService } from "../../../service/ApiService";

import { useBlogSelectors } from "../../../store/blog/blog.selectors";
import { BlogAction } from "../../../store/blog/blog.slice";

import { sliderSettings } from "../../../utils/helpers";
import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useGetBlogContent, useScrollToTop } from "../../../hooks";

import { Container, Slider } from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import { Subscribe } from "../../../components/common/Subscribe/Subscribe";
import { addStyles } from "./addStyles";
import BlogTabs from "./components/BlogTabs";
import { CardList } from "./components/CardList/CardList";

import { Section } from "../../../components/common/Section/Section.styled";
import { WrapperSlider } from "./Blog.styled";

const Blog = () => {
  useScrollToTop();
  useGetBlogContent();

  const { allFacts } = useBlogSelectors();

  return (
    <>
      <Container>
        <Section variant="startTop">
          <HeadUpperSeo />
        </Section>

        <BlogTabs />

        <WrapperSlider>
          <Slider
            settings={sliderSettings}
            slideFullWidth={true}
            addStyles={addStyles}
            blog={+true}
            facts={allFacts}
          />
        </WrapperSlider>

        <CardList />
      </Container>
      <Faq />
      <Seo />

      <Subscribe />
    </>
  );
};

Blog.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);

  const page = Number(params.params.page || "1") - 1;
  const tab = params.params.tab || "all";
  const locale = params.locale;
  const size = 9;

  const fetchParams = {
    page,
    size,
    tab,
    sortDirection: "desc",
    languageCode: locale,
  };

  try {
    const blogData = await ApiService.getBlogContent(fetchParams);

    if (blogData) {
      store.dispatch(BlogAction.saveServerBlogContent(blogData.data));
    }
  } catch (e) {
    console.log("Blog: Error in fetch blog, ", e.message);
  }

  try {
    const factsData = await ApiService.getBlogFacts(locale);

    if (factsData) {
      store.dispatch(
        BlogAction.saveServerBlogFacts({
          data: factsData.data,
          languageCode: locale,
        }),
      );
    }
  } catch (e) {
    console.log("Blog: Error in fetch blog facts, ", e.message);
  }
};

export default Blog;
